import $ = require("jquery");
import Portal = require("portal-gis");
import Utils = require("../utils");
import FeatureService = require("../services/ags/feature-service-reader");
import Mediator = require("../mediator");
import View = require("./base/geoquery-form-tool");

class Tool extends View {

    static about = `
Generates a filter form from a feature services.

Usage Example:

    <CONTROL id="ags-geoquery-form-tool-military-lines" mid="app/controls/ags-geoquery-form-tool" text="Military Lines" type="execute">
    <OPTIONS>
        <Values id="url" value="//sampleserver6.arcgisonline.com/arcgis/rest/services/Military/FeatureServer/4" />
        <Values id="key-template" value="&lt;%=objectid%&gt;" />
        <Values id="blacklist" value="ruleid,azimuth,datetimevalid,datetimeexpired,eny,objectid,additionalinformation" />
    </OPTIONS>
    <COMMANDS>
        <COMMAND id="geoquery-form-search" mid="app/commands/trigger" text="Search" type="action">
        <OPTIONS>
            <Values id="event" value="ags-geoquery-execute" />
        </OPTIONS>
        </COMMAND>
    </COMMANDS>
    </CONTROL>

    `;

    static options = Utils.defaults({
        "symbology": {
            "about": "",
        },
        "url": {
            "about": "Ags Feature Service Discovery endpoint",
        },
    }, View.options);

    createForm(args = this.args) {
        let options = this.options;

        Utils.ifOption(options, "url", url => {

            // get symbology from url

            FeatureService.discover({ url: url }).done(layer => {

                // make sure map is aware of this new symbology
                {
                    var config = <Portal.MapApplicationElement>{
                        Map: {
                            Symbology: layer.symbols
                        }
                    };

                    // overwrite the label with the control text?
                    this.configuration.text && config.Map.Symbology.Symbols.forEach(s => s.Label = this.configuration.text + (s.Label ? " " + s.Label : ""));
                    Utils.ifOption(options, "symbology", v => config.Map.Symbology.Symbols.forEach(s => s.id = v));

                    this.mediator.api.merge(config);
                }

                super.createForm({
                    metadata: layer.fields,
                    symbology: layer.symbols.id
                });
            });

        });

    }

}

export = Tool; 